import {useQuery} from "@tanstack/react-query";
import {
  CategoryApi,
  SectorApi,
  SubCategoryApi,
} from "../services/CategoryService";

export const useGetCatgeory = () => {
  const {data, isLoading, isError, error} = useQuery({
    queryKey: ["category"],
    queryFn: () => CategoryApi.getAll(),
    select: (data) => data.rows,
    staleTime: 10 * 60 * 1000,
    refetchOnWindowFocus: false,
  });

  return {
    data,
    isLoading,
    isError,
    error,
  };
};

export const useGetCategoryById = (id) => {
  const {data, isLoading, isError, error} = useQuery({
    queryKey: ["category", id],
    queryFn: () => CategoryApi.getOne(id),
  });

  return {
    data,
    isLoading,
    isError,
    error,
  };
};

export const useGetSectors = () => {
  const {data, isLoading, isError, error} = useQuery({
    queryKey: ["sectors"],
    queryFn: () => SectorApi.getAll(),
    select: (data) => data.rows,
    staleTime: 10 * 60 * 1000,
    refetchOnWindowFocus: false,
  });

  return {
    data,
    isLoading,
    isError,
    error,
  };
};

export const useGetSubCategories = () => {
  const {data, isLoading, isError, error} = useQuery({
    queryKey: ["subCategories"],
    queryFn: () => SubCategoryApi.getAll(),
    select: (data) => data.rows,
    staleTime: 10 * 60 * 1000,
    refetchOnWindowFocus: false,
  });

  return {
    data,
    isLoading,
    isError,
    error,
  };
};
